import Title from "./title";

const Body = () => {
  return (
    <main className="flex-grow w-full">
      <Title />
      <section className="w-full h-[100px] mobile:h-[50px]"></section>
    </main>
  );
};

export default Body;
